import React from "react";
import { Grid, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
    graphql,
    graphqlOperation,
    postApi
} from "../../modules/AmplifyServices";
import { updateCompany } from "../../graphql/mutations";
import "./connect.css";
import { updateCompanyObjectInCachedUser } from "../../user/UserCommon";

function StripeConnect(props) {
    async function saveStateAndLoadStripe() {
        props.setShowLoading(true);
        try {
            localStorage.setItem("stripeConnectFlowAdminApp", "");
            const result = await postApi("stripeconnect", "/onboarduser", {
                body: {
                    fromApp: "adminapp",
                    stripeAccountId: props.stripeAccountId
                }
            });
            localStorage.setItem(
                "stripeConnectFlowAdminApp",
                JSON.stringify({
                    companyId: props.companyId,
                    timestamp: Date.now()
                })
            );
            if (!props.stripeAccountId)
                await saveStripeAccountId(result.accountId, props.companyId);
            props.setShowLoading(false);
            window.location = result.url;
        } catch (e) {
            console.log(e);
            props.setShowLoading(false);
        }
    }

    async function saveStripeAccountId(stripeAccountId, companyId) {
        try {
            let response = await graphql(
                graphqlOperation(updateCompany, {
                    input: {
                        id: companyId,
                        stripeAccount: stripeAccountId
                    }
                })
            );
            await updateCompanyObjectInCachedUser(
                response?.data?.updateCompany
            );
        } catch (e) {
            console.log("error", e);
        }
    }

    return (
        <Grid container spacing={2.25} flexDirection={"row"}>
            <Grid item sx={{ alignContent: "center" }}>
                <Button
                    disabled={
                        props.connected || (!props.enabled && !props.connected)
                    }
                    component={Link}
                    to="#"
                    variant="contained"
                    color="primary"
                    sx={{ "&:hover": { color: "white" } }}
                    onClick={async (e) => {
                        e.preventDefault();
                        await saveStateAndLoadStripe();
                    }}
                >
                    Connect Stripe
                </Button>
            </Grid>
            <Grid item sx={{ alignContent: "center" }}>
                {props.connected && (
                    <Typography color={"verified"} sx={{ fontWeight: "700" }}>
                        Connected
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
}

export default StripeConnect;
